import { Collapse, CollapseProps, Fade, useMediaQuery } from "@mui/material";

// Keep height and opacity transitions in sync throughout the sign-in flow.
export default function AuthTransition({
  in: open,
  children,
  onEntered,
}: Pick<CollapseProps, "in" | "children" | "onEntered">) {
  const prefersReducedMotion = useMediaQuery("(prefers-reduced-motion: reduce)");
  const duration = prefersReducedMotion ? 0 : 220;

  return (
    <Collapse in={open} timeout={duration} onEntered={onEntered} unmountOnExit>
      <Fade in={open} timeout={duration}>
        <div inert={!open} aria-hidden={!open}>
          {children}
        </div>
      </Fade>
    </Collapse>
  );
}
